import { Onboarding } from '@/onboarding/layout/OnboardingPageTemplate'
import { KycRequirements } from '@/kyc/KycRequirements'
import { ONBOARDING_COPY } from '@/locales/en'
import { FullScreenLoader } from '@/common/ui/FullScreenLoader'
import { Mail } from 'lucide-react'
import { AccountType } from '@/common/types'
import { KycProviders } from '@/kyc/types'

export type PageProps = {
    progress?: number
    accountType?: AccountType
    provider?: KycProviders | null
    loading?: boolean
    saving?: boolean
    disabled?: boolean
    canInitiate?: boolean
}

interface ViewModelProps extends PageProps {
    /** Start KYC handler — *required for production use*; may be omitted in Storybook previews. */
    onStart?: () => void
    /** Skip KYC handler — *required for production use*; may be omitted in Storybook previews. */
    onSkip?: () => void
}

export function KycInitForm({
    progress = 45,
    accountType = AccountType.INDIVIDUAL,
    provider,
    loading,
    saving,
    disabled,
    canInitiate = true,
    onStart,
    onSkip,
}: ViewModelProps) {
    const isDisabled = Boolean(disabled) || Boolean(loading) || Boolean(saving) || !canInitiate

    if (loading && !provider) {
        return <FullScreenLoader dark />
    }

    const frankieOneOnboarding = provider === KycProviders.FRANKIEONE

    return (
        <Onboarding
            title={ONBOARDING_COPY.kycInit.title}
            description={ONBOARDING_COPY.kycInit.description}
            progress={progress}
            onSubmit={(e) => {
                e.preventDefault()
                onStart?.()
            }}
            cta={ONBOARDING_COPY.kycInit.primaryButton}
            disabled={isDisabled}
            isLoading={saving}
            secondaryAction={{
                label: ONBOARDING_COPY.kycInit.secondaryButton,
                onClick: onSkip || (() => {}),
                variant: 'ghost',
            }}
        >
            <KycRequirements frankieOneOnboarding={frankieOneOnboarding} accountType={accountType} />
            {!frankieOneOnboarding && (
                <div className="flex border gap-6 items-start px-4 py-4">
                    <div className="flex items-start pt-1">
                        <Mail className="w-6 h-6" data-testid="mail-icon" />
                    </div>
                    <div className="flex flex-col gap-4 pt-1">
                        <h3 className="text-start font-medium font-body">{ONBOARDING_COPY.kycInit.alert.title}</h3>
                        <p className="text-[#737671]">{ONBOARDING_COPY.kycInit.alert.description}</p>
                    </div>
                </div>
            )}
        </Onboarding>
    )
}
